export const comments_3296373 = {"data":{"data":[],"links":{}}}